import { Pagination, Tag } from "antd";
import { QData } from "../../types/basic-type-list";

type MyPaginationProps = {
  qData: QData;
  total: number;
  onChange?: (newQData: QData) => void;
};

export default function MyPagination({ qData, total, onChange }: MyPaginationProps) {
  const page = qData.page ?? 1;
  const limit = qData.limit ?? 20;

  const handleChange = (newPage: number, newLimit: number) => {
    if (newLimit !== limit) {
      onChange?.({ ...qData, page: 1, limit: newLimit });
    } else {
      onChange?.({ ...qData, page: newPage, limit: newLimit });
    }
  };

  const showTotal = () => {
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);
    return <Tag>{`Showing ${start} - ${end} of ${total}`}</Tag>;
  };

  if (total === 0) return null;

  return (
    <Pagination
      total={total}
      showTotal={showTotal}
      pageSize={limit}
      current={page}
      onChange={handleChange}
      showSizeChanger
      pageSizeOptions={["10", "20", "50", "100"]}
    />
  );
}
